import { ProgressBar } from 'baseui/progress-bar'
import { CodeProgressOverrides, StyledCode, StyledCodeBox, StyledCodeExpiry } from './styled-components'

export interface RegistrationCodeProps {
  hidden: boolean
  code: string
  expiryLabel: string
  progress: { value: number; maxValue: number }
}

const RegistrationCode = ({ hidden, code, expiryLabel, progress }: RegistrationCodeProps) => {
  if (hidden) {
    return null
  }

  return (
    <StyledCodeBox>
      <StyledCode>{code}</StyledCode>
      <StyledCodeExpiry>{expiryLabel}</StyledCodeExpiry>
      <ProgressBar value={progress.value} maxValue={progress.maxValue} overrides={CodeProgressOverrides} />
    </StyledCodeBox>
  )
}

export default RegistrationCode
